module.exports = __webpack_public_path__ + "img/spartan-build-design-01-tablet.9cbb5b20.jpg";